import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const WrappedPage = lazy(() => import('../components/WrappedPage'));

export function wrappedRoutes() {
	return <Route path={FRONTEND_ROUTES.WRAPPED} element={<WrappedPage />} />;
}
